<template>
  <div class="login-method f fd-c">
    <el-divider>or</el-divider>
    <el-button v-if="loginMethod === 'email'" class="btn f--c" style="margin-bottom:12px;" @click="changeLoginMethod('phone')"><img src="https://img.kakaclo.com/web-img/home/login/icon_1.png" alt="">Continue with Phone Number</el-button>
    <el-button v-else class="btn f--c" style="margin-bottom:12px;" @click="changeLoginMethod('email')"><img src="https://img.kakaclo.com/web-img/home/login/icon_3.png" alt="">Continue with Email</el-button>
    <el-button class="btn f--c" data-onsuccess="googleLoginSuccessCb"><img src="https://img.kakaclo.com/web-img/home/login/icon_2.png" alt="" @click="handleClick">Continue with Google
      <div class="g-signin2" data-onsuccess="googleLoginSuccessCb" @click="handleClick"></div>
    </el-button>
  </div>
</template>

<script>
import googleLoginMixin from '../../js/googleLogin.js'
export default {
  mixins: [googleLoginMixin],
  props: {
    loginMethod: {
      type: String,
      require: true,
      default: 'email'
    }
  },
  data() {
    return {}
  },
  methods: {
    changeLoginMethod(method) {
      this.$emit('changeLoginMethod', method)
    },
    handleClick() {
      this.isClickGoogle = true
      this.$emit('clickGoogle')
    }
  }
}
</script>

<style lang="scss" scoped>
.login-method {

  .btn {
    position: relative;
    margin:0;
    padding: 0;
    /deep/ span {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }

    .g-signin2 {
      position: absolute;
      width: 100%;
      opacity: 0;
      /deep/ div {
        width: 100% !important;
      }
    }
  }

  /deep/ .el-divider--horizontal {
    margin: 30px 0;
  }
  /deep/ .el-divider__text{
    color: #909399;
  }
  /deep/ .el-button {
    height: 40px;
    border-radius: 2px;
  }
}
</style>
